import { render, staticRenderFns } from "./salePrescription.vue?vue&type=template&id=6f336c56&"
import script from "./salePrescription.vue?vue&type=script&lang=js&"
export * from "./salePrescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports